export function sanitizeNumberFormat(value: string) {
	// Remove everything except numbers
	return value.replace(/[^\d]/g, "")
}
